import React, { useState } from 'react'
import { Toast } from './../UI/toast/Toast'
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes'
import { fetchProperties } from '../../helpers/api/condominium'
import PageHeader from '../common/PageHeader'
import handleErrorMessage from '../../helpers/errors/handleErrorMessage'
import withRedirect from '../../helpers/hoc/withRedirect'
import { useParams } from 'react-router'
import { createAliquot } from '../../helpers/api/finance'
import { useSelector } from 'react-redux'
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination'
import CreateAliquotForm from './CreateAliquotForm'
import { PreloadState } from '../UI/preloading/PreloadState'
import SupportLink from '../root/support/components/SupportLink'
import useModuleBase from "../../helpers/hooks/useModuleBase";

const CreateAliquot = ({ setRedirectUrl, setRedirect }) => {

    const moduleBase = useModuleBase();

    const { id } = useParams();
    const { selectedCondominium } = useSelector(state => state.condominium);
    const [params] = useState({
        condominiumId: selectedCondominium
    })
    const {
        data,
        isLoading,
        meta,
        handler: { nextPage, previousPage, perPage, goToPage }
    } = useSWRFetchPagination(fetchProperties, params);

    const create = async values => {
        try {

            const { code, warning } = await createAliquot(values);

            if (code === SUCCESS_RESPONSE.CREATED) {
                setRedirectUrl(`/dashboard/${moduleBase}/${id}/aliquots`);
                setRedirect(true);
                Toast.fire({
                    type: 'success',
                    title: `Alícuota registrada exitosamente.`,
                });
                if (warning) {
                    Toast.fire({
                        type: 'warning',
                        title: warning,
                        timer: 8000,
                    });
                }
            }
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    return <>
        <PageHeader
            title="Añadir alícuota"
            titleTag="h2"
            description="Asigna una alícuota a un propietario de tu condominio."
            className="mb-3"
            col={{ lg: 9 }}
        >
            <SupportLink/>
        </PageHeader>
        <PreloadState loading={isLoading}>
            <CreateAliquotForm handleSubmitData={create} handler={{ nextPage, previousPage, perPage, goToPage, meta }} properties={data} />
        </PreloadState>
    </>
}

export default withRedirect(CreateAliquot);